import fp from 'lodash/fp';
import React, { useCallback } from 'react';
import { messaging } from '@factorin/container.macro';

import { useAction } from 'Modules/core/redux';
import { useTranslation } from 'Modules/core/i18n';
import { messagingActions } from 'Modules/core/messaging';
import { Typography } from 'Modules/ui3';


export const CryptoProfileButton = ({ className, hide, hasNoPermissions }) => {
    const { t } = useTranslation('profileButtons');

    const showCryptoProfilesModal = useAction(
        () => messagingActions.showModal({
            type: fp.has('CoCryptoProfilesModal', messaging.modalTypes)
                ? 'CoCryptoProfilesModal'
                : 'ReadOnlyCryptoProfilesManager',
        }),
    );
    const showModalWithClosePopup = useCallback(
        () => {
            showCryptoProfilesModal();
            hide();
        },
        [hide, showCryptoProfilesModal],
    );

    if (hasNoPermissions)
        return null;

    return (
        <Typography
            variant='regularBody2'
            component='button'
            className={className}
            onClick={showModalWithClosePopup}
        >
            {t('cryptoProfileButton')}
        </Typography>
    );
};
